import React from 'react';

import { ContainerInner } from '../common/ContainerInner';
import { useNavigate } from 'react-router-dom';

type Props = {
    readonly productId: string;
};

function ProductNotFound({ productId }: Props) {
    const navigate = useNavigate();

    return (
        <ContainerInner>
            <div className="no-elements">
                <h4>
                    Product with id <em>{productId}</em> could not be found.
                </h4>
                <a onClick={() => navigate(-1)} className="bt bt-green large back">
                    <i className="material-icons big">keyboard_backspace</i> Go back
                </a>
            </div>
        </ContainerInner>
    );
}

export default ProductNotFound;
